import { render, staticRenderFns } from "./PazienteTeleconsultoComponent.vue?vue&type=template&id=d33f5a5c&scoped=true"
import script from "./PazienteTeleconsultoComponent.vue?vue&type=script&lang=js"
export * from "./PazienteTeleconsultoComponent.vue?vue&type=script&lang=js"
import style0 from "./PazienteTeleconsultoComponent.vue?vue&type=style&index=0&id=d33f5a5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33f5a5c",
  null
  
)

export default component.exports